module.exports = __webpack_public_path__ + "media/wd-siteH265.99106428.mp4";